import React from "react";
import Colgroup from "./Colgroup";
import {
	StyledTable,
	StyledTableWrapper,
	TableBody,
	TableHead,
	TableNoResultText,
	TableTd,
	TableTdProps,
	TableTr,
} from "./style";

interface TableProps {
	col: number[];
	headItems: Array<string | React.ReactNode>;
	headProps?: TableTdProps[];
	rowItems: Array<Array<string | React.ReactNode>>;
	rowProps?: TableTdProps[];
	noResultText?: string;
}

export default function Table({
	col,
	headItems,
	headProps,
	rowItems,
	rowProps,
	noResultText = "데이터가 없습니다",
}: TableProps) {
	const getPropsWithIndex = (index: number, propsArray?: TableTdProps[]) => {
		if (!propsArray) {
			return {};
		}

		if (propsArray[index]) {
			return propsArray[index];
		}

		return {};
	};

	return (
		<StyledTableWrapper>
			<StyledTable>
				<Colgroup col={col} />
				<TableHead>
					<TableTr>
						{headItems.map((headValue, headIndex) => (
							<TableTd
								key={`th-td-${headIndex}`}
								{...getPropsWithIndex(headIndex, headProps)}
							>
								{headValue}
							</TableTd>
						))}
					</TableTr>
				</TableHead>
				<TableBody>
					{rowItems.length > 0 &&
						rowItems.map((rowLineValue, rowLineIndex) => (
							<TableTr key={`tr-${rowLineIndex}`}>
								{rowLineValue.map((rowValue, rowIndex) => (
									<TableTd
										key={`tr-td-${rowIndex}`}
										{...getPropsWithIndex(rowIndex, rowProps)}
									>
										{rowValue}
									</TableTd>
								))}
							</TableTr>
						))}
				</TableBody>
			</StyledTable>
			{rowItems.length <= 0 && (
				<TableNoResultText>{noResultText}</TableNoResultText>
			)}
		</StyledTableWrapper>
	);
}
